import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import {BDPGlyph} from '../common/_BDPLogo.jsx';
import WebinarBanner from '../common/_WebinarBanner.jsx';

export default class HelpCenterHeader extends BLComponent {
	constructor (props, context) {
		super(props, context);
	}

	render() {
		return (
			<header className="crowd-help__header">
				<div className="edge-to-edge-container__internal">
					<WebinarBanner/>
					<div className="crowd-help__header-internal">
						<div className="bdp-glyph-inline">
							<BDPGlyph/>
						</div>
						<h1 className="crowd-help__header-title">{this.props.title}</h1>
					</div>
				</div>
			</header>
		);
	}
}